import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'App',
  components: {},
  setup: function setup() {
    var contentHtml = ref('Hello world!');

    var getContent = function getContent(content, id) {
      console.log('id=', id);
      contentHtml.value = content;
    };

    var save = function save() {
      alert(contentHtml.value);
    };

    return {
      getContent: getContent,
      contentHtml: contentHtml,
      save: save
    };
  }
});